<script>
  import { blocklist, text, richtext, image, url, exists } from "../toolbox.js";
  import { link } from "svelte-routing";
  
  export let block;
</script>

<div class="container marketing">
  <!-- Three columns of text below the carousel -->
  <div class="row">

    {#each blocklist(block, 'features') as item}
    <div class="col-lg-4">
      <div class="bd-placeholder-img">
        <img class=" rounded-circle" src="{image(item, 'pic', [400, 400])}" alt="" width="140" height="140">
      </div>
      <h2>{text(item, 'headline')}</h2>
      <p>{@html richtext(item, 'main')}</p>
      <p><a class="btn btn-secondary" href="{url(item, 'button')}" use:link>
          {text(item, 'button')} &raquo;</a>
      </p>
    </div><!-- /.col-lg-4 -->
    {/each}

  </div><!-- /.row -->
</div>
